var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-card",
    { attrs: { bordered: false } },
    [
      _c(
        "div",
        { staticClass: "table-page-search-wrapper" },
        [
          _c(
            "a-form",
            {
              attrs: { layout: "inline" },
              nativeOn: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.searchQuery($event)
                }
              }
            },
            [
              _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { md: 6, sm: 8 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "content" } },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入content" },
                            model: {
                              value: _vm.queryParam.content,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "content", $$v)
                              },
                              expression: "queryParam.content"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { md: 5, sm: 8 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          staticStyle: { left: "10px" },
                          attrs: { label: "api类型" }
                        },
                        [
                          _c("j-dict-select-tag", {
                            attrs: {
                              placeholder: "api类型",
                              dictCode: "hhemp_aicsp_apitype"
                            },
                            model: {
                              value: _vm.queryParam.apiType,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "apiType", $$v)
                              },
                              expression: "queryParam.apiType"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { md: 5, sm: 8 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          staticStyle: { left: "10px" },
                          attrs: { label: "convertTextToSpeech" }
                        },
                        [
                          _c("j-dict-select-tag", {
                            attrs: {
                              placeholder: "convertTextToSpeech",
                              dictCode: "hhemp_isthird"
                            },
                            model: {
                              value: _vm.queryParam.convertTextToSpeech,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.queryParam,
                                  "convertTextToSpeech",
                                  $$v
                                )
                              },
                              expression: "queryParam.convertTextToSpeech"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "table-page-search-submitButtons",
                      staticStyle: { float: "left", overflow: "hidden" }
                    },
                    [
                      _c(
                        "a-col",
                        { attrs: { md: 6, sm: 24 } },
                        [
                          _c(
                            "a-button",
                            {
                              attrs: { type: "primary", icon: "search" },
                              on: { click: _vm.searchQuery }
                            },
                            [_vm._v("查询")]
                          ),
                          _c(
                            "a-button",
                            {
                              staticStyle: {
                                "margin-left": "8px",
                                left: "10px"
                              },
                              attrs: { type: "primary", icon: "reload" },
                              on: { click: _vm.searchReset }
                            },
                            [_vm._v("重置")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-operator" },
        [
          _c(
            "a-button",
            {
              attrs: { type: "primary", icon: "plus" },
              on: { click: _vm.handleAdd }
            },
            [_vm._v("接口调用测试")]
          ),
          _c(
            "a-button",
            {
              attrs: { type: "primary", icon: "plus" },
              on: { click: _vm.handleQandA }
            },
            [_vm._v("问答")]
          )
        ],
        1
      ),
      _c(
        "div",
        [
          _c("a-table", {
            ref: "table",
            staticClass: "j-table-force-nowrap",
            attrs: {
              size: "middle",
              scroll: { x: 1000 },
              bordered: "",
              rowKey: "id",
              columns: _vm.columns,
              dataSource: _vm.dataSource,
              pagination: _vm.ipagination,
              loading: _vm.loading
            },
            on: { change: _vm.handleTableChange },
            scopedSlots: _vm._u([
              {
                key: "expandedRowRender",
                fn: function(record) {
                  return _c("div", { staticStyle: { margin: "0" } }, [
                    _c(
                      "div",
                      { staticStyle: { "margin-bottom": "5px" } },
                      [
                        _c("a-badge", {
                          staticStyle: { "vertical-align": "middle" },
                          attrs: { status: "success" }
                        }),
                        _c(
                          "span",
                          { staticStyle: { "vertical-align": "middle" } },
                          [_vm._v("content:" + _vm._s(record.content))]
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      [
                        _c("a-badge", {
                          staticStyle: { "vertical-align": "middle" },
                          attrs: { status: "processing" }
                        }),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "vertical-align": "middle",
                              "word-break": "break-all",
                              "white-space": "pre-wrap"
                            }
                          },
                          [_vm._v("响应结果:" + _vm._s(record.responseResult))]
                        )
                      ],
                      1
                    )
                  ])
                }
              },
              {
                key: "logContent",
                fn: function(text, record) {
                  return _c(
                    "span",
                    {},
                    [_c("j-ellipsis", { attrs: { value: text, length: 20 } })],
                    1
                  )
                }
              },
              {
                key: "contentSimpSlot",
                fn: function(text, record) {
                  return _c("span", {}, [
                    record.responseResult &&
                    (record.apiType === "chatWithKnowledge" ||
                      record.apiType === "cspChatWithKnowledge")
                      ? _c(
                          "div",
                          [
                            _c(
                              "a-button",
                              {
                                attrs: { type: "link" },
                                on: {
                                  click: function($event) {
                                    return _vm.showModal(record)
                                  }
                                }
                              },
                              [_vm._v("查看")]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    !(
                      record.responseResult &&
                      (record.apiType === "chatWithKnowledge" ||
                        record.apiType === "cspChatWithKnowledge")
                    )
                      ? _c("div", [_c("span", [_vm._v("无")])])
                      : _vm._e()
                  ])
                }
              },
              {
                key: "contentAudioSlot",
                fn: function(text, record) {
                  return _c("span", {}, [
                    record.responseResult && record.convertTextToSpeech === "1"
                      ? _c(
                          "div",
                          [
                            _c(
                              "a-button",
                              {
                                attrs: { type: "link" },
                                on: {
                                  click: function($event) {
                                    return _vm.showModal2(record)
                                  }
                                }
                              },
                              [_vm._v("播放")]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    !(
                      record.responseResult &&
                      record.convertTextToSpeech === "1"
                    )
                      ? _c("div", [_c("span", [_vm._v("无")])])
                      : _vm._e()
                  ])
                }
              },
              {
                key: "processTypeSlot",
                fn: function(text, record) {
                  return _c("span", {}, [
                    record.responseResult &&
                    record.apiType === "chatWithKnowledge"
                      ? _c("div", [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                JSON.parse(record.responseResult).processType
                              ) +
                              "\n            "
                          )
                        ])
                      : _vm._e(),
                    !(
                      record.responseResult &&
                      record.apiType === "chatWithKnowledge"
                    )
                      ? _c("div", [_c("span", [_vm._v("无")])])
                      : _vm._e()
                  ])
                }
              },
              {
                key: "htmlSlot",
                fn: function(text) {
                  return [_c("div", { domProps: { innerHTML: _vm._s(text) } })]
                }
              },
              {
                key: "imgSlot",
                fn: function(text) {
                  return [
                    !text
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              "font-style": "italic"
                            }
                          },
                          [_vm._v("无图片")]
                        )
                      : _c("img", {
                          staticStyle: {
                            "max-width": "80px",
                            "font-size": "12px",
                            "font-style": "italic"
                          },
                          attrs: {
                            src: _vm.getImgView(text),
                            height: "25px",
                            alt: ""
                          }
                        })
                  ]
                }
              },
              {
                key: "fileSlot",
                fn: function(text) {
                  return [
                    !text
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              "font-style": "italic"
                            }
                          },
                          [_vm._v("无文件")]
                        )
                      : _c(
                          "a-button",
                          {
                            attrs: {
                              ghost: true,
                              type: "primary",
                              icon: "download",
                              size: "small"
                            },
                            on: {
                              click: function($event) {
                                return _vm.downloadFile(text)
                              }
                            }
                          },
                          [_vm._v("\n            下载\n          ")]
                        )
                  ]
                }
              },
              {
                key: "action",
                fn: function(text, record) {
                  return _c(
                    "span",
                    {},
                    [
                      _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              return _vm.handleEdit(record)
                            }
                          }
                        },
                        [_vm._v("编辑")]
                      ),
                      _c("a-divider", { attrs: { type: "vertical" } }),
                      _c(
                        "a-dropdown",
                        [
                          _c(
                            "a",
                            { staticClass: "ant-dropdown-link" },
                            [
                              _vm._v("更多 "),
                              _c("a-icon", { attrs: { type: "down" } })
                            ],
                            1
                          ),
                          _c(
                            "a-menu",
                            { attrs: { slot: "overlay" }, slot: "overlay" },
                            [
                              _c("a-menu-item", [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.handleDetail(record)
                                      }
                                    }
                                  },
                                  [_vm._v("详情")]
                                )
                              ]),
                              _c(
                                "a-menu-item",
                                [
                                  _c(
                                    "a-popconfirm",
                                    {
                                      attrs: { title: "确定删除吗?" },
                                      on: {
                                        confirm: function() {
                                          return _vm.handleDelete(record.id)
                                        }
                                      }
                                    },
                                    [_c("a", [_vm._v("删除")])]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                }
              }
            ])
          })
        ],
        1
      ),
      _c("emp-aicsp-log-modal", {
        ref: "modalForm",
        on: { ok: _vm.modalFormOk }
      }),
      _c("QandA", { ref: "modalQandA" }),
      _c(
        "a-modal",
        {
          attrs: { title: "查看详细信息" },
          on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
          model: {
            value: _vm.isModalVisible,
            callback: function($$v) {
              _vm.isModalVisible = $$v
            },
            expression: "isModalVisible"
          }
        },
        [_c("p", [_vm._v(_vm._s(_vm.modalText))])]
      ),
      _c(
        "a-modal",
        {
          attrs: { title: "播放" },
          on: { ok: _vm.handleOk2, cancel: _vm.handleCancel2 },
          model: {
            value: _vm.isModalVisible2,
            callback: function($$v) {
              _vm.isModalVisible2 = $$v
            },
            expression: "isModalVisible2"
          }
        },
        [
          _c("audio", {
            ref: "audioElement",
            attrs: { src: _vm.modalSrc, controls: "" }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }